import { SalesTransaction, SalesTransactionDetail, SalesTransactionPayments } from './sales-transaction.model';
import { PointMutation } from './point-mutation.model';
import { MemberPoint } from './member-point.model';
import { MstVoucherDetail } from './mst-voucher.model';
import { StockMutation } from './stock-mutation.model';
import { MstPromotionDetail } from './mst-promotion.model';

export class SalesTransactionBundle {

    salesTransaction: SalesTransaction;
    salesTransactionDetail: SalesTransactionDetail;
    salesTransactionPayments: SalesTransactionPayments;
    pointMutation: PointMutation;
    memberPoint: MemberPoint;
    mstVoucherDetail: MstVoucherDetail;
    stockMutation: StockMutation;
    freePromoMutation: StockMutation;
    mstPromotionDetail: MstPromotionDetail;
    member:string[];
    redeem:string[];
    referralCode:any='';
    bringItem: { id: number; amount: number }[];
    receipt:any='';
    voucherNonMember:any='';
    voucherNonMemberValue:any='';
    pointCalculation:any='N';
    generalVoucher:any='';
    generalVoucherValue:number=0;

    constructor(model?) {
        model = model || {};
        this.salesTransaction = model.salesTransaction || new SalesTransaction();
        this.salesTransactionDetail = model.salesTransactionDetail || new SalesTransactionDetail();
        this.salesTransactionPayments = model.salesTransactionPayments || new SalesTransactionPayments();
        this.pointMutation = model.pointMutation || new PointMutation();
        this.memberPoint = model.memberPoint || new MemberPoint();
        this.mstVoucherDetail = model.mstVoucherDetail || new MstVoucherDetail();
        this.stockMutation = model.stockMutation || new StockMutation();
        this.freePromoMutation = model.freePromoMutation || new StockMutation();
        this.mstPromotionDetail = model.mstPromotionDetail || new MstPromotionDetail();
        this.member = model.member || [];
        this.redeem = model.redeem || [];
        this.bringItem = model.bringItem || [];
        this.referralCode = model.referralCode || '';
        this.receipt = model.receipt || '';
        this.voucherNonMember = model.voucherNonMember || '';
        this.voucherNonMemberValue = model.voucherNonMemberValue || 0;
        this.pointCalculation = model.pointCalculation || 'N';
        this.generalVoucher = model.generalVoucher || '';
        this.generalVoucherValue = model.generalVoucherValue || 0;
    }
}